import React from "react";
import { Link } from "react-router-dom";
import { APP_ROUTE_PATHS } from "../appRoutePaths";
import {
  getFeatureDefinition,
  getFeatureAccessDecision,
  MANUCALC_PLANS,
} from "../data/featureTiers";
import { getAccessState } from "../utils/accessControl";

export const hasFeatureAccess = ({
  feature,
  user,
  trialStatus,
  subscriptionStatus,
  accountProfile,
}) => {
  const accessState = getAccessState({ user, trialStatus, subscriptionStatus, accountProfile });
  return getFeatureAccessDecision({
    feature,
    accountProfile,
    subscriptionStatus,
    trialStatus,
    hasBaseAccess: accessState.hasAccess,
  }).allowed;
};

const FeatureGate = ({
  feature,
  user,
  trialStatus,
  subscriptionStatus,
  accountProfile,
  children,
  fallback = null,
}) => {
  const accessState = getAccessState({ user, trialStatus, subscriptionStatus, accountProfile });
  const decision = getFeatureAccessDecision({
    feature,
    accountProfile,
    subscriptionStatus,
    trialStatus,
    hasBaseAccess: accessState.hasAccess,
  });
  const definition = getFeatureDefinition(feature);
  const allowed = decision.allowed;

  if (allowed) return <>{children}</>;
  if (fallback) return fallback;

  const plan = MANUCALC_PLANS[definition.minimumPlan] || MANUCALC_PLANS.lite;
  return (
    <section className="feature-gate-panel">
      <span>Upgrade Required</span>
      <h2>{definition.label}</h2>
      <p>
        This workflow is available on {plan.name}. Your current access is
        {` ${decision.currentPlanName}`}. The feature stays visible so teams can understand
        what is available without hitting a blank screen.
      </p>
      {decision.benefits.length > 0 && (
        <ul>
          {decision.benefits.map((benefit) => <li key={benefit}>{benefit}</li>)}
        </ul>
      )}
      <Link to={APP_ROUTE_PATHS.billing}>View Plans</Link>
    </section>
  );
};

export default FeatureGate;
